/**
 * Whether the preview still waits on the AI comment.
 *
 * A report builder run sets `isCommentLoading` until the comment request settles, so a failed
 * or empty comment ends the wait. Other callers carry only `comment`.
 */
export function isCommentPending({ comment, isCommentLoading }) {
  if (typeof isCommentLoading === 'boolean') return isCommentLoading;
  return !comment;
}
